<template>
    <div style="position: fixed; top: 0; left: 0; display: flex; align-items: center; gap: 15px; z-index: 1; ">
        <div class="container" :class="{blue: blue, purple: purple}">
            <div class="menu unselectable" v-click-outside="hideSubMenu">
                <div class="menuBtn" @click="clickEvt">
                    <img src='../assets/menu2.png' style="width: 60%">   
                </div>
                <SubMenu v-show="isExpand" :value="menu" left
                    :blue="blue" :purple="purple"
                    @save="$emit('save')"
                    @load="$emit('load', $event)"
                    @clean="$emit('clean')"
                    @close="hideSubMenu"/>
            </div>
            <div class="title unselectable">
                <slot name="title"/>
            </div>
        </div>
    </div>
</template>

<script>
import SubMenu from '@/ui/SubMenu'
import clickOutside from '@/directives/clickOutside';

export default {
    name: "Menu",
    emits: ['clean', 'save', 'load'],
    props:{
        blue: {
            type: Boolean,
            default: false,
        },
        purple: {
            type: Boolean,
            default: false,
        },
        menu: {
            type: Array,
            default: null
        },
        simple: {
            type: Boolean,
            default: false
        }
    },
    components: {
        SubMenu,
    },
    directives: {
        clickOutside
    },
    data(){
        return {
            isExpand: false,
        }
    },
    methods:{
        clickEvt(){
            this.isExpand = !this.isExpand
        },
        hideSubMenu(){
            if (this.isExpand) {
                this.isExpand = false
            }
        }
    },
}
</script>

<style scoped>
.container{
    display: flex; align-items: center; gap: 10px; height: max-content; z-index: 1;
    height: 45px;
    padding: 30px 20px;
    background: white;
    border-top: none;
    border-left: none;
    border-radius:  0 0 15px 0;

    width: max-content;
    min-width: 215px;
    border-right: none;

    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.menu{
    width: 30px; height: 30px; 
    padding: 0;
}

.menuBtn{
    width: 100%; height: 100%;
    background: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
}

.menuBtn:hover{
    background: #bbb;
}

.menuBtn:active{
    background: #aaa;
}

.title{
    color: #000;
    font-size: 18px; 
    font-weight: 700;
    
    display: flex; 
    align-items: center;
    gap: 10px;

    width: max-content;
    height: max-content;
    max-height: 60px;
    white-space:nowrap;
}

.container.blue .title{
    color: #1967D2;
}

.container.blue .menuBtn{
    background: #4285F4;
}

.container.blue .menuBtn:hover{
    background: #1967D2;
}

.container.blue .menuBtn:active{
    background: #185abc;
}

.container.purple .title{
    color: #8a66c7;
}

.container.purple .menuBtn{
    background: #9a72e0;
}

.container.purple .menuBtn:hover{
    background: #8a66c7;
}

.container.purple .menuBtn:active {
    background: #7053A3;
}
</style>